import { US_STATES } from "../../constants/usStates";

function val(input) {
  return input ? input : "-";
}

function thirdPartyTypes(patient) {
  const types = [];
  if (patient.thirdPartyPremise) types.push("Premise");
  if (patient.thirdPartyAuto) types.push("Auto");
  if (patient.thirdPartyUmbrella) types.push("Umbrella");
  return types.length ? types.join(", ") : "-";
}

function stateLabel(code) {
  if (!code) return "-";
  const found = US_STATES.find((state) => state.code === code);
  return found ? `${found.name} (${found.code})` : code;
}

export default function PatientInsuranceReadOnly({ patient }) {
  return (
    <>
      <section className="form-section">
        <h3 className="form-section-title">Commercial Health</h3>
        <p>
          <strong>Insurance Name:</strong> {val(patient.commercialInsuranceName)}
        </p>
        <p>
          <strong>Insured Name:</strong> {val(patient.commercialInsuredName)}
        </p>
        <p>
          <strong>Member ID Number:</strong> {val(patient.commercialMemberId)}
        </p>
        <p>
          <strong>Group Number:</strong> {val(patient.commercialGroupNumber)}
        </p>
      </section>

      <section className="form-section">
        <h3 className="form-section-title">Auto</h3>
        <p>
          <strong>Carrier Name:</strong> {val(patient.autoCarrierName)}
        </p>
        <p>
          <strong>Policy Number:</strong> {val(patient.autoPolicyNumber)}
        </p>
        <p>
          <strong>Claim Number:</strong> {val(patient.autoClaimNumber)}
        </p>
        <h4 className="form-subsection-title">Coverage Information</h4>
        <p>
          <strong>Med Pay Amount:</strong> {val(patient.autoMedPayAmount)}
        </p>
        <p>
          <strong>State Of Issuance:</strong> {stateLabel(patient.autoStateOfIssuance)}
        </p>
        <p>
          <strong>Total Benefit:</strong> {val(patient.autoTotalBenefit)}
        </p>
        <p>
          <strong>UM Amount:</strong> {val(patient.autoUmAmount)}
        </p>
        <p>
          <strong>Adjuster&apos;s Name:</strong> {val(patient.autoAdjusterName)}
        </p>
        <p>
          <strong>Adjuster&apos;s Phone Number:</strong> {val(patient.autoAdjusterPhone)}
        </p>
        <p>
          <strong>Adjuster&apos;s Email:</strong> {val(patient.autoAdjusterEmail)}
        </p>
      </section>

      <section className="form-section">
        <h3 className="form-section-title">Third Party</h3>
        <p>
          <strong>Type:</strong> {thirdPartyTypes(patient)}
        </p>
        <p>
          <strong>Carrier&apos;s Name:</strong> {val(patient.thirdPartyCarrierName)}
        </p>
        <p>
          <strong>Coverage:</strong> {val(patient.thirdPartyCoverage)}
        </p>
      </section>
    </>
  );
}
